import { endpoints } from "../../../config";
import appClient from "./AppClient";

export default class DocumentService {
    async getXmlDocumentContent(documentId: string) {
        const url = endpoints.tasksUrl + `document/${documentId}/xml`;
        return appClient.get<string>(url, "text");
    }
}
